<script>
  import Dropzone from "../dropzone/Dropzone.svelte";
  import { Icon, Spinner } from 'sveltestrap';
  import { api_url } from "../ConfigService.js";
  import { Styles, Button } from 'sveltestrap';
  import { navigate } from 'svelte-routing';
  import Tooltip from "./Tooltip.svelte";
  
  export let folder=false;
  export let orderno;
  export let token;
  export let reload=false;
  export let needUpdate=false;
  
  let files = {
    accepted: [],
    uploaded: [],
    uploading: [],
    rejected: []
  };
  
  function generateOrderNumber() {
    const datePart = new Date().toISOString().slice(2, 10).replace(/-/g, ""); // YYMMDD
    const chars = "ABCDE0123456789";
    let randomPart = "";

    for (let i = 0; i < 4; i++) {
        randomPart += chars[Math.floor(Math.random() * chars.length)];
    }
    return `${datePart}-${randomPart}`;
  }


  function handleFilesSelect(e) {
    const { acceptedFiles, fileRejections } = e.detail;
    files.accepted = [...files.accepted, ...acceptedFiles];
    files.rejected = [...files.rejected, ...fileRejections];
  }

  function removeFromUploading(item) {
  	//  	files.uploading.splice(files.uploading.indexOf(item), 1);
  	let newUploading=[];
  	for(let i=0; i<files.uploading.length; i++) {
  		if(files.uploading[i]!=item) { newUploading.push(files.uploading[i]); }
  	}
  	files.uploading=newUploading;
  }
  
  function removeFromAccepted(item) {
  	let newUploading=[];
  	for(let i=0; i<files.accepted.length; i++) {
  		if(files.accepted[i]!=item) { newUploading.push(files.accepted[i]); }
  	}
  	files.accepted=newUploading;
  }
  
  function removeFromUploaded(item) {
  	let newUploading=[];
  	for(let i=0; i<files.uploaded.length; i++) {
  		if(files.uploaded[i]!=item) { newUploading.push(files.uploaded[i]); }
  	}
  	files.uploading=newUploading;
  }


    async function upload(f) {
    	if(files.uploaded.includes(f) || files.uploading.includes(f) ||files.rejected.includes(f) ) { 
    		return true;
    	} else {
		files.uploading.push(f); 
		removeFromAccepted(f);
		const formData = new FormData();
		formData.append("folder", folder);
		formData.append("file", f);
		const response = await fetch($api_url+"upload.php?orderno="+orderno, {
			method: "POST",
			body: formData,
		});
		const data = await response.json();
		if (!response.ok) {
			removeFromUploading(f); 
			files.rejected.push(f); 
		} else {
			removeFromUploading(f); 
			if(!files.uploaded.includes(f)) { files.uploaded.push(f); }
			if(await data) {
				if(await data.status.includes("Nepovolený") || await data.status.includes("překročil") || await data.status.includes("Chyba")) {
					if(!files.rejected.includes(f)) { files.rejected.push(f); }
					removeFromUploaded(f);
				}
			}
		}

		if(await data.orderno) {
			orderno=await data.orderno;
		}
		if(await data.token) {
			token=await data.token;
		}
	}
  }
  
  function reset() {
	  files = {
	    accepted: [],
	    uploaded: [],
	    uploading: [],
	    rejected: []
	  };
  	needUpdate=true;
  }
  
  function nextStep(o, t) {
  	if(t) { navigate('/photos/'+o+'/'+t); }
  	else { navigate('/photos/'+o); }
  }
  
  $: {
  	if(!orderno) { orderno=generateOrderNumber(); }
  }
  
</script>

<div class="uploader-dropzone">
	<Dropzone on:drop={handleFilesSelect} accept="image/*" />
	<br />
	<center><i>Maximální velikost jednoho souboru: 20MB</i></center>
</div>
<br>
<ol>
  {#each files.accepted as item}
  	{#if upload(item)}
  		&nbsp;
  	{/if}
  {/each}
  {#each files.uploading as item}
    <li>
    	{item.name} 
    	<span class="icon"><Spinner color="info" size="sm" /></span>
    </li>
  {/each}
  {#each files.uploaded as item}
    <li>
    	{item.name} 
    	<span class="icon success"><Icon name="patch-check-fill" /></span>
    </li>
  {/each}
  {#each files.rejected as item}
    <li>
    	{item.name} 
    	<span class="icon error">
    		<Tooltip text="Fotografii se nepodařilo nahrát! Zkontrolujte prosím, zda je ve formátu jpg a nepřekračuje povolenou velikost." maxWidth="400"><Icon name="exclamation-octagon-fill" /></Tooltip>
    	</span>
    </li>
  {/each}
</ol>

{#if orderno && files.uploaded.length>0 && files.uploading.length==0}
	<center>
		{#if reload}
			<Button color="primary" outlined on:click={()=>reset()}>Zobrazit nově nahrané fotografie</Button>
		{:else}
			<Button color="primary" outlined on:click={()=>nextStep(orderno, token)}>Pokračovat na výběr formátů</Button>
		{/if}
	</center>
{/if}

<style>
.uploader-dropzone { cursor:pointer; }
.icon { padding-left:10px; font-size:22px; }
.error { color:red; }
.success { color:green }
</style>

